"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var deleteInvitation = function (id) {
    return (0, service_1.getService)()
        .delete("/shares/".concat(id))
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .catch(function (_a) {
        var response = _a.response;
        return Promise.reject(response.data);
    });
};
exports.default = deleteInvitation;
